var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.146,
    height: 20,
    viewBox: "0 0 19.146 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "solid_cog",
    "data-name": "solid cog",
    d: "M37.545,20.5l-1.718-.992a7.767,7.767,0,0,0,0-2.831l1.718-.992a.487.487,0,0,0,.222-.565,10.043,10.043,0,0,0-2.206-3.815.485.485,0,0,0-.6-.093l-1.718.992A7.61,7.61,0,0,0,30.8,10.793V8.813a.483.483,0,0,0-.379-.472,10.137,10.137,0,0,0-4.4,0,.483.483,0,0,0-.379.472V10.8a7.85,7.85,0,0,0-2.452,1.415l-1.714-.992a.479.479,0,0,0-.6.093,9.982,9.982,0,0,0-2.206,3.815.482.482,0,0,0,.222.565l1.718.992a7.767,7.767,0,0,0,0,2.831l-1.718.992a.487.487,0,0,0-.222.565,10.043,10.043,0,0,0,2.206,3.815.485.485,0,0,0,.6.093l1.718-.992A7.61,7.61,0,0,0,25.638,25.4v1.984a.483.483,0,0,0,.379.472,10.137,10.137,0,0,0,4.4,0,.483.483,0,0,0,.379-.472V25.4a7.85,7.85,0,0,0,2.452-1.415l1.718.992a.479.479,0,0,0,.6-.093,9.982,9.982,0,0,0,2.206-3.815A.5.5,0,0,0,37.545,20.5Zm-9.331.819A3.226,3.226,0,1,1,31.44,18.1,3.23,3.23,0,0,1,28.215,21.321Z",
    transform: "translate(-18.644 -8.099)",
    fill: "#fc1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settings-icon.5fe48e8bae88975f7024efa31a10d030.svg";
export { ForwardRef as ReactComponent };